<template lang="html">
<div>
  <div class='order-item' :class="{'row-collapse': !isReturnIndent}">
    <div class="order-row" v-bind:class="{ 'overdue': $statusUtil.getStatusIds(['indent_assign_due']).includes(order.status),
      'flash': order.order_number === latestUpdated,
      'alert-list alert-red': errorMessage.length }">
      <Alert v-if="errorMessage.length" size="large"  type="info" width="auto" trigger="click" :closable="false">
        <span v-for="error in errorMessage">{{error}}</span>
      </Alert>
      <div class="order-col pointer" @click="getOrderDetails('INDENT_DETAILS')"  v-for="(label, index) in headers"  v-bind:key="index" v-bind:class="getClass(label.css_class)">
        <div>
          <span v-if="!isReturnIndent && hasChildIndents && index ===0">
            <span class="row-expand" v-bind:class="{'is-toggle': isExpandView}" @click="toggleExpandView"></span>
          </span>
          <span v-if="label.data.key !=='status'">
            <Ellipsis
              v-if="label.expanded_text"
              :text="rowLabel(order, label)"
              :length="label.truncate_on"
              :expandedContext="rowLabel(order, label.expanded_text)"/>
            <Ellipsis
              v-else
              :text="rowLabel(order, label)"
              :length="label.truncate_on"/>
          </span>
          <div v-else v-bind:class="getStatus(order.status)">
            <div class="order-status-button">
              {{$t(statusName(order.status))}}
              <div class="order-status-button_ps">
                <Tooltip class="item" effect="dark" placement="bottom">
                  <div slot="content" class="tooltipcontent">
                    {{getOrderType}}|{{getMovement}}|{{getPtlOrFtl}}
                    <span v-if="simTrackingEnabled">|Sim Tracking</span>
                    <span v-if="gpsTrackingEnabled">|Gps Tracking</span>
                  </div>
                  <button v-if="!isPackingIndentEnabled">
                    <svgicon :name="getSvgClassIndent" width="10" height="10" />
                    <svgicon :name="getSvgClassMovement" width="10" height="10" />
                    <svgicon v-if="isPTLOrder" name="ptl" width="12" height="12" />
                    <svgicon v-if="simTrackingEnabled" name="icon-simcard" width="12" height="12" />
                    <svgicon v-if="gpsTrackingEnabled" name="icon-transit" width="12" height="12" />
                  </button>
                  <button v-else>
                      <svgicon
                        :name="modeOfTransporterIcon"
                        v-if="order.ship_pack_details && order.ship_pack_details.mode_of_transport && modeOfTransporterIcon"
                        width="8" height="8"
                      />
                      <svgicon name="icon-status-hazardous" v-if="order.isHazardMaterialIndent"  width="10" height="10" :original="true" />
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>
          <div class="datelabel" v-if="label.dependency && label.dependency.is_enabled">
            <Ellipsis :text="rowLabel(order, label.dependency)" :length="label.dependency.truncate_on"/>
          </div>
        </div>
      </div>
      <div class="order-col order-actions" v-if="!isPackingIndentEnabled">
        <div class="ml-auto">
        <span v-if="!$statusUtil.getStatusIds(['drafted']).includes(order.status)"> <!-- not in draft status -->
        <!--Truck Utilization-->
        <div class="action px-0"
          v-if="(order.approval_status && showUtilization && $statusUtil.getStatusIds(['delivered','delivery_pending','loading_ended']).includes(order.status) &&
            filter.category === orderType.CONTRACT)">
          <Popover placement="bottom-end" v-model="truckUtilization"
            popper-class="popzindex largepopup">
            <div class="popover-primary">
              <div class="popover-primary-header">
                <h3>{{$t('INDENT_UPDATE_VEHICLE')}}</h3>
                <span class="remove-icon" @click="truckUtilization=false">
                  <svgicon name="cancelblack" width="12" height="12" :original="true" />
                </span>
              </div>
              <div class="popover-primary-body">
                <div v-if="truckUtilizationDetails" >
                  <TruckUtilization
                  :order="order"
                  :getMovemntsTypes="movementTypes"
                  :utilizationStatus="utilizationStatus"
                  :movement="movementTypes"
                  @done="hide"
                  :truckUtilizationDetails="truckUtilizationDetails"
                  />
                </div>
                <div v-else>{{$t('INDENT_LOADING')}}..</div>
              </div>

            </div>
            <div class="link-action" slot="reference" @click="getUtilization"
              :class="{'color-error': [utilizationStatus.PENDING, utilizationStatus.REJECTED]
                .includes(order.approval_status)}">
              <svgicon name="eway-error" width="12" height="12" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_UPDATE')}}</span>
            </div>
          </Popover>
        </div>
        <!--Truck Utilization-->
<!-- Edit Truck In in Delpending, Delivered-->
        <div class="action px-0" v-if="$statusUtil.getStatusIds(['dispatched','delivery_pending']).includes(order.status) &&
         $hasPermission('edit_truckinout_timestamp') && !isLastMileEnabled &&
            filter.category === orderType.CONTRACT">
          <Popover
          placement="bottom-end"
          width="420"
          :visible-arrow="true"
          popper-class="popover-list bordered"
          :reference="this.$refs.editTruckIn"
          v-model="editTruckin">
          <div class="popover-wrapper">
            <div class="popover-title">
              {{$t('INDENT_EDIT_TRUCK_IN')}}
              <i class="close" @click="editTruckin=false">
                <svgicon name="cancelblack-trans" width="12" height="12" />
              </i>
            </div>
            <EditTruckin :order="order"
            :datePickerFormat="datePickerFormat"
            :truckDetainedConfig="truckDetainedConfig"
            ref="editTruckIn"
            @done="closeTruckTimestampUpdate">
            </EditTruckin>
          </div>
          <span class="link-action" v-bind:class="{ 'action-green': isTruckinTruckoutChanged }" slot="reference">
            <svgicon name="icon-action-truck-in" width="10" height="10" />
            {{$t('INDENT_EDIT_TRUCK_IN')}}
          </span>
        </Popover>
        </div>
        <!-- Edit Truck In-->


        <!-- Freight-->
        <div class="action px-0" v-if="order.order_type === 1 && ($hasPermission('add_freight_charge') || $hasPermission('override_freight_charge')) && !$statusUtil.getStatusIds(['requested']).includes(order.status)">
            <!-- <FreightCharge
              v-if="addFreight"
              :order="order"
              :baseFreight="order.base_frieght"
              :baseFreightAttachmentMandatory="baseFreightAttachmentMandatory"
              @closeFreight="closeFreightPop"
            /> -->
            <div class="link-action" slot="reference"
              :class="{'color-error': !order.base_frieght. freight_charge}" @click="addFreightAmount()">
              <svgicon name="freight-universal"
                v-if="!order.base_frieght.freight_charge"
                width="10" height="10"
                :original="true" />
            <svgicon name="freight-universal" v-else width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_FREIGHT')}}</span>
        </div>
      </div>

        <!-- Quotes-->
        <div class="action px-0" v-if="showQuotes()" @click ="getQuotes()">
              <svgicon name="quote" width="12" height="12" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_QUOTES')}}</span>
        </div>
        <!-- Quotes-->

        <!--Re-indent-->
        <div class="link-action" v-if="showReindent() && (!isRoundTrip)">
          <div @click="setSelectedAction('RE_INDENT')">
            <svgicon name="re-indent" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_RE_INDENT')}}</span>
          </div>
        </div>
        <div class="link-action" v-permission="['indent_view_truck_change_requested']"
          v-if="$statusUtil.getStatusIds(['truck_change_requested']).includes(order.status) && $hasFeature('transporter_change_truck_type')">
          <template v-if="order.has_truck_change_approval_flow">
            <div @click="setSelectedAction(indentActions.UPDATE_VEHICLE_TYPE)">
              <svgicon name="icon_vehicle" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed"> {{$t('INDENT_CHANGE_REQUEST')}}</span>
            </div>
          </template>
          
          <template v-else>
            <Popover placement="bottom-end" v-model="truckChangeRequest" popper-class="popzindex">
              <div class="popover-primary">
                <div class="popover-primary-header">
                  <h3>{{$t('INDENT_CHANGE_REQUEST')}}</h3>
                  <span class="remove-icon" @click="truckChangeRequest=false">
                    <svgicon name="cancel" width="10" height="10" :original="true" />
                  </span>
                </div>
                <div class="popover-primary-body">
                  <TruckChangeRequest :order="order" :sob="sob"
                    v-on:re-indent="showReindent; showReindentDialog=true;"
                    @done="hide"
                    v-on:accept="acceptTruckRequest"
                    v-on:continue="denyTruckChangeRequest"/>
                </div>
              </div>
              <div slot="reference" @click="getComments()">
                <svgicon name="link" width="10" height="10" :original="true" />
                {{$t('INDENT_CHANGE_REQUEST')}}
              </div>
            </Popover>
          </template>
        </div>
        <!-- Freight Change Request -->
        <div class="action px-0" v-permission="['approve_freight_change_request']" v-if="hasFreightChangeRequested">
          <Popover placement="bottom-end" v-model="showFreightChangeRequestPopup" popper-class="popzindex">
            <div class="popover-primary">
              <div class="popover-primary-header">
                <h3>{{$t('INDENT_FREIGHT_CHANGE_REQUEST')}}</h3>
                <span class="remove-icon" @click="showFreightChangeRequestPopup=false">
                  <svgicon name="cancel" width="10" height="10" :original="true" />
                </span>
              </div>
              <div class="popover-primary-body">
                <FreightChangeRequest
                  :order="order"
                  @accept="acceptFreightChangeRequest"
                  @reject="rejectFreightChangeRequest" />
              </div>

            </div>
            <div class="link-action" slot="reference" @click="showFreightChangeRequestPopup=true">
              <svgicon name="link" width="10" height="10" :original="true" />
              {{$t('INDENT_FREIGHT_CHANGE_REQUEST')}}
            </div>
          </Popover>
        </div>

        <!-- CHANGE TRUCK if truck is assigned, -->
        <div class="link-action"
          v-permission="['indent_truck_view']"
          v-if="hasTruck && !($statusUtil.getStatusIds(['indent_assign_due','indent_accept_due']).includes(order.status)) && !isReturnIndent"
          @click="setSelectedAction(indentActions.UPDATE_TRUCK)">
          <svgicon name="icon_vehicle" width="10" height="10" :original="true" />
          <span v-if="isFilterClosed">{{order.vehicle.number}}</span>
        </div>

        <!-- ASSIGN TRUCK if order is indented-->
        <div class="link-action" v-permission="['indent_truck_view']"
             v-if="[0, 3, 20, 21, 22].includes(order.status) &&
             !order.vehicle.number && !isReturnIndent"
             @click="assignTruck">
            <svgicon name="icon_vehicle" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_VEHICLE')}}</span>
        </div>
        <!-- MARK AS DELIVERED TEST -->
        <div class="action px-0"
        v-if="$hasFeature('shipper_mark_as_delivered') && !isLastMileEnabled &&
          $statusUtil.getStatusIds(['dispatched']).includes(order.status) &&
          filter.category === orderType.CONTRACT && isMarkAsDeliverEnable"
          @click="markAsDelivered">
          <svgicon name="mark-as-delivered" width="10" height="10" />
          {{$t('INDENT_MARK_AS_DELIVERED')}}
        </div>
              <!-- MARK AS DELIVERED-->
      <!-- <div class="action px-0"
        v-if="$hasFeature('shipper_mark_as_delivered') &&
          order.status === 6 &&
          filter.category === orderType.CONTRACT && isMarkAsDeliverEnable">
        <Popover placement="bottom-end" v-model="markasdelivered" popper-class="popzindex">
          <div class="popover-primary">
            <div class="popover-primary-header">
              <h3>{{$t('INDENT_MARK_AS_DELIVERED')}}</h3>
              <span class="remove-icon" @click="markasdelivered=false">
                <svgicon name="cancel" width="10" height="10" :original="true" />
              </span>
            </div>
            <div class="popover-primary-body max-height">
              <MarkAsDelivered
                :order="order"
                :datePickerFormat="datePickerFormat"
                :getBackDateConfig="getBackDateConfig"
                :isPrimary="movementTypes.PRIMARY === order.movement"
                :inbound="filter.category === orderType.OPEN"
                :truckDetainedConfig="truckDetainedConfig"
                @done="hide"/>
            </div>
          </div>
          <div class="link-action" slot="reference" @click="$emit('setGA', 'Click', 'Mark as Delivered')">
            <svgicon name="mark-as-delivered" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_MARK_AS_DELIVERED')}}</span>
          </div>
        </Popover>
      </div> -->

      <div class="action px-0" v-permission="['inbound_mark_deliver']"
           v-if="$statusUtil.getStatusIds(['dispatched']).includes(order.status) && filter.category === orderType.OPEN &&
            !isLastMileEnabled" @click="markAsDelivered">
          <svgicon name="mark-as-delivered" width="10" height="10" />
          {{$t('INDENT_MARK_AS_DELIVERED')}}
      </div>


        <!-- ADD DOCKS -->
        <div class="action px-0"
          v-permission="['indent_view_docks']"
            v-if="$depot.gatesHasDocks(orderGates) && !isDispatched && $hasFeature('docks')
            && (!$statusUtil.getStatusIds(['indent_rejected']).includes(order.status)) && (!$statusUtil.getStatusIds(['indent_assign_due','indent_accept_due','indent_arrived_due']).includes(order.status))">
          <Popover
            placement="bottom-end"
            popper-class="popover-medium popzindex"
            v-model="addDocks" @show="fetchOrder">
            <div class="popover-primary">
              <div class="popover-primary-header">
                <h3>{{$t('INDENT_ADD_DOCKS')}}</h3>
                <span class="remove-icon" @click="addDocks=false">
                  <svgicon name="cancel" width="10" height="10" :original="true" />
                </span>
              </div>
              <div class="popover-primary-body">
                <div v-if="!isOrderLoading" >
                  <AddDocks :order="order" @done="hide"/>
                </div>
              </div>
            </div>
            <div class="link-action" slot="reference">
              <svgicon name="add" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_DOCKS')}}</span>
            </div>
          </Popover>
        </div>
        <div v-permission="['indent_report_at_depot']"
          v-if="isMasterIndentActionCompleted &&
            !showContainerBooked && $statusUtil.getStatusIds(['truck_assigned','indent_arrived_due','container_picked']).includes(order.status) &&
            $hasFeature('reported_at_depot') && !order.reported_at &&
            !$hasPermission('special_truck_in')" class="link-action"
          @click="truckReported">
          <svgicon name="truckin" width="10" height="10" :original="true" />
          <span v-if="isFilterClosed">{{$t('INDENT_REPORTED')}}</span>
        </div>
        <!--  CONTAINER PICKED -->
        <div v-permission="['update_container_number']" class="action px-0" v-if="showContainerBooked && !isLastMileEnabled">
          <div v-if="isMasterIndentActionCompleted">
          <Popover placement="bottom-end" v-model="containerPickup" trigger="click" @show="fetchOrder" popper-class="popzindex">
            <div class="popover-primary">
              <div class="popover-primary-header">
                <h3>{{$t('INDENT_CONTAINER_PICKED')}}</h3>
                <span class="remove-icon" @click="containerPickup=false">
                  <svgicon name="cancel" width="10" height="10" :original="true" />
                </span>
              </div>
              <div class="popover-primary-body">
                <div v-if="!isOrderLoading">
                  <ContainerPickup :order="order" @done="hide"/>
                </div>
                <div v-else>{{$t('INDENT_LOADING')}}..</div>
              </div>
            </div>
            <div class="link-action" slot="reference">
              <svgicon name="truckin" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_CONTAINER_PICKUP')}}</span>
            </div>
          </Popover>
             </div>
          <div v-else class="action-disabled">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{$t('INDENT_CONTAINER_NOT_BOOKED')}}</div>
              <span class="pointer">
                <svgicon name="truckin" width="10" height="10" :original="true" />
                <span v-if="isFilterClosed">{{$t('INDENT_CONTAINER_PICKUP')}}</span>
              </span>
            </Tooltip>
          </div>
        </div>
        <!-- LAST MILE ACTIONS-->
        <div class="action">
          <div v-if="isLastMileEnabled && showLastMileActions">
            <div class="link-action" slot="reference" @click="onLastMileActions">
              <svgicon name="icon-inspection" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed">{{$t('LAST_MILE_ACTIONS')}}</span>
            </div>
          </div>
        </div>
        <!--  TRUCK IN -->
        <div v-permission="['indent_truck_in']" class="action"
          v-if="!showGatePass && showTruckIn && !isLastMileEnabled">
          <div v-if="enableTruckIn.enabled">
            <div class="link-action" slot="reference" @click="onLoadTruckIn">
              <svgicon name="truckin" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_TRUCK_IN')}}</span>
            </div>
          </div>
          <div v-else class="action-disabled">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark"
              placement="bottom-start">
                <div slot="content">{{enableTruckIn.reason}}</div>
                <span class="pointer">
                  <svgicon name="truckin" width="10" height="10" :original="true" />
                  <span v-if="isFilterClosed">{{$t('INDENT_TRUCK_IN')}}</span>
                </span>
              </Tooltip>
          </div>

        </div>

        <!-- REACHED LOADING POINT  for NON DOCKS-->
        <div class="link-action"
          v-permission="['indent_at_load_point']"
          v-if="$hasFeature('track_first_load_point') && currentGate && !isLastMileEnabled &&
          !(currentGate && !!currentGate.load_point_arrived_at) && hasVendorActionsPermission &&
          $statusUtil.getStatusIds(['truck_arrived']).includes(order.status) && !$depot.gateHasDocks(currentGate.gate_id) && !$hasPermission('special_truck_in')"
          @click="onReachedFirstLoadingPoint">
          <svgicon name="reached-loadingpoint" width="10" height="10" :original="true" />
          <span v-if="isFilterClosed">{{$t('INDENT_REACHED_LOADING_POINT')}}</span>
        </div>

        <!-- REACHED LOADING POINT for  DOCKS -->
        <div class="action" v-permission="['indent_at_load_point']"
          v-if="$hasFeature('track_first_load_point') &&
          $statusUtil.getStatusIds(['truck_arrived']).includes(order.status)  && currentGate &&
          $depot.gateHasDocks(currentGate.gate_id) &&
          !(currentGate && !!currentGate.load_point_arrived_at) && !$hasPermission('special_truck_in')">
          <div class="link-action" v-if="currentGateHasDocks" @click="onReachedFirstLoadingPoint">
            <svgicon name="reached-loadingpoint" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_REACHED_DOCK')}}</span>
          </div>
           <div v-else class="action-disabled">
            <svgicon name="reached-loadingpoint" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_REACHED_DOCK')}}</span>
          </div>
        </div>

        <div class="action"
          v-if="$hasPermission('indent_start_load') && !isLastMileEnabled && isLoadingAtSourceEnabled &&
          currentGate && hasCurrentGateAccess && hasVendorActionsPermission &&
          $depot.gateHasDocks(currentGate.gate_id) && ($statusUtil.getStatusIds(['truck_arrived','loading_ended','loading_started']).includes(order.status)) &&
          truckReachedFirstLoadingPoint && isDockToLoadPending">
          <div
            v-if="$depot.gateHasDocks(currentGate.gate_id) && !yetToAddDocks">
            <div v-if="!isOrderLoading" class="link-action" slot="reference" @click="onLoadStartAtGate">
              <svgicon name="loading-start" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_START_LOAD')}}</span>
            </div>
          </div>

        </div>

        <!-- LOADING ENDED, if loading started in docks -->
        <div class="action" v-if="$hasPermission('indent_end_load') && !isLastMileEnabled && isLoadingAtSourceEnabled &&
          ( $statusUtil.getStatusIds(['loading_started','loading_ended']).includes(order.status)) &&
          loadingInProgressInDock && hasCurrentGateAccess && hasVendorActionsPermission">
            <div v-if="!isOrderLoading"  class="link-action" slot="reference" @click="onLoadEndAtGate">
              <svgicon name="loading-end" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_END_LOAD')}}</span>
            </div>
        </div>

        <!-- START LOADING IN GATE -->
        <div class="link-action" v-permission="['indent_start_load']"
          v-if="startLoadEnable && $statusUtil.getStatusIds(['truck_arrived']).includes(order.status) && currentGate &&
          hasCurrentGateAccess && hasVendorActionsPermission && !isLastMileEnabled && isLoadingAtSourceEnabled
          && !$depot.gateHasDocks(currentGate.gate_id) && truckReachedFirstLoadingPoint">
          <div @click="onLoadStartAtGate">
            <svgicon name="loading-start" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_START_LOAD')}}</span>
          </div>
        </div>

        <div class="link-action" v-permission="['indent_end_load']"
          v-if="$statusUtil.getStatusIds(['loading_started']).includes(order.status) && currentGate &&
          hasCurrentGateAccess && hasVendorActionsPermission && !isLastMileEnabled &&
          isLoadingAtSourceEnabled && !$depot.gateHasDocks(currentGate.gate_id)">
          <div @click="onLoadEndAtGate">
            <svgicon name="loading-end" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_END_LOAD')}}</span>
          </div>
        </div>

        <div class="action" v-if="$hasPermission('indent_truck_out') && truckOutEnable && !isLastMileEnabled">
          <div v-if="truckOutDisableCheck.notDisabled" >
            <div class="link-action" slot="reference" @click="truckOut()">
              <svgicon name="truckout" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_TRUCK_OUT')}}</span>
            </div>
          </div>
          <div v-else class="action-disabled">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark"
             placement="bottom-start">
              <div slot="content">{{truckOutDisableCheck.reason}}</div>
              <span class="pointer">
                <svgicon name="truckout" width="10" height="10" :original="true" />
                <span v-if="isFilterClosed">{{$t('INDENT_TRUCK_OUT')}}</span>
              </span>
            </Tooltip>
          </div>
        </div>

          <div class="action" v-if="showEmptyContainerReturned">
            <Popover placement="bottom-end"
            trigger="click" @show="fetchOrder"
            width="420"
            popper-class="popover-list bordered"
            v-model="emptyContainerReturned"
            >
             <div class="popover-wrapper">
               <div class="popover-title">
                <h3>{{$t('INDENT_EMPTY_CONTAINER_RETURNED')}}</h3>
                <i class="close"  @click="emptyContainerReturned=false">
                   <svgicon name="cancel" width="12" height="12" />
                </i>
              </div>
               <div class="popover-body p-0">
                <div v-if="!isOrderLoading" >
                  <EmptyContainerReturned
                    :order="order"
                    :getBackDateConfig="getBackDateConfig"
                    :eximCustomFields="eximCustomFields"
                    @done="hide"
                  />
                </div>
                <div v-else>{{$t('INDENT_LOADING')}}..</div>
              </div>
            </div>
            <div class="link-action" slot="reference">
              <svgicon name="truckout" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_EMPTY_CONTAINER_RETURNED')}}</span>
            </div>
          </Popover>
        </div>

        <div class="action"
          v-if="isEximImport &&
            (!$statusUtil.getStatusIds(['indented','truck_change_requested','indent_rejected','indent_accepted','indent_assign_due','indent_accept_due','requested','delivered','delivery_pending','cancelled']).includes(order.status))"
        >
            <Popover placement="bottom-end"
              trigger="click"
              @show="fetchOrder"
              width="420"
              popper-class="popover-list bordered"
              v-model="ewayBill">
              <div class="popover-wrapper">
               <div class="popover-title">
                <h3>{{$t('INDENT_EWAY_BILL')}}</h3>
                <i class="close" @click="ewayBill=false">
                  <svgicon name="cancel" width="12" height="12" />
                </i>
              </div>
              <div class="popover-body p-0">
                <div v-if="!isOrderLoading" >
                  <EwayBill
                    :order="order"
                    :getBackDateConfig="getBackDateConfig"
                    :eximCustomFields="eximCustomFields"
                    @done="hide"
                  />
                </div>
                <div v-else>{{$t('INDENT_LOADING')}}..</div>
              </div>
            </div>
            <div class="link-action" slot="reference">
              <svgicon name="truckout" width="10" height="10" :original="true" />
              <span v-if="isFilterClosed">{{$t('INDENT_EWAY_BILL')}}</span>
            </div>
          </Popover>
        </div>
        <div class="d-inline-flex document" v-if="!$hasPermission('hide_lr_details') && order.lorry_receipt.length">
          <Popover placement="bottom-end" v-model="showLrDetails" popper-class="popzindex">
          <div class="payment-popover popover-primary">
            <div class="popover-primary-header">
              <h3>{{$t('INDENT_LR_DETAILS')}}</h3>
              <span class="remove-icon" @click="showLrDetails=false">
                <svgicon name="cancel" width="10" height="10" :original="true" />
              </span>
            </div>
            <div class="popover-primary-body table-popover scrollheaderfix">
              <div class="popover-table">
                <div class="popover-table-header">
                  <div class="card-col w250">
                  {{$t('INDENT_CONSIGNEE_NAME')}}
                  </div>
                  <div class="card-col w150">
                  {{$t('INDENT_LR_NUMBER')}}
                  </div>
                </div>
                <div class="popscroll">
                <div class="popover-table-row" v-for="(lr, index) in orderLRDetails" :key="index">
                  <div v-for="(lr_number, index_lr) in lr.lrNos" :key="index_lr">
                  <div class="card-col w250">
                    <Ellipsis v-if="lr.consigneeName.length" :text="lr.consigneeName" :length="27" />
                  </div>
                  <div class="card-col w250">
                    <Ellipsis :text="lr_number" :length="25" />
                  </div>
                  </div>
            </div>
              </div>
            </div>
            </div>
          </div>
          <div class="link-action" slot="reference" @click="getLRDetails()">
            <svgicon name="lr" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_LR_NUMBERS')}}</span>
          </div>
           </Popover>
        </div>
        <div class="d-inline-flex document" v-if="$hasFeature('indent_listing_view_delivery_numbers')">
          <Popover placement="bottom-end" v-model="showDeliveryNumbers" popper-class="popzindex">
            <div v-if="orderDeliveryNumbers && orderDeliveryNumbers.length">
          <div class="payment-popover popover-primary">
             
            <div class="popover-primary-header">
              <h3>{{$t('INDENT_DELIVERY_DETAILS')}}</h3>
              <span class="remove-icon" @click="showDeliveryNumbers=false">
                <svgicon name="cancel" width="10" height="10" :original="true" />
              </span>
            </div>
            <div class="popover-primary-body table-popover scrollheaderfix">
              <div class="popover-table">
                <div class="popover-table-header">
                  <div class="card-col w150">
                  {{$t('INDENT_DELIVERY_NUMBER')}}
                  </div>
                </div>
                <div class="popscroll">
                <div  class="popover-table-row" v-for="(dn, index) in orderDeliveryNumbers" :key="index">
                  <div class="card-col w250">
                    <Ellipsis :text="dn" :length="25" />
                  </div>
            </div>
              </div>
            </div>
            </div>
          </div>
          
          </div>
          <div v-else>
            <div class="payment-popover popover-primary">
              <div class="popover-primary-header">
                <h3>{{$t('INDENT_DELIVERY_DETAILS')}}</h3>
                <span class="remove-icon" @click="showDeliveryNumbers=false">
                  <svgicon name="cancel" width="10" height="10" :original="true" />
                </span>
              </div>
              <div class="popover-primary-body table-popover scrollheaderfix py-20 pb-0">
                <span> No Delivery Numbers Found</span>
              </div>
            </div>
          </div>
          <div class="link-action" slot="reference" @click="handleDN()">
             <svgicon name="lr" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_DELIVERY_NUMBERS')}} </span>
          </div>
           </Popover>
        </div>
        <!--Update EDD-->
        <div class="link-action"
          v-if="($hasPermission('update_expected_delivery_at_after_dispatch')
          && order.order_type === orderType.OPEN &&
            $statusUtil.getStatusIds(['dispatched','delivery_pending']).includes(order.status))"
            @click="$emit('setGA', 'Click', 'Change EDD')">
          <Popover placement="bottom-end" v-model="updateEdd" popper-class="popzindex largepopup">
            <div class="popover-primary">
              <div class="popover-primary-header">
                <h3>{{$t('INDENT_UPDATE_EDD')}}</h3>
                <span class="remove-icon" @click="updateEdd=false">
                  <svgicon name="cancelblack" width="12" height="12" :original="true" />
                </span>
              </div>
              <div class="popover-primary-body">
                 <UpdateEdd :order="order" @done="hide" />
              </div>

            </div>
            <div slot="reference" :class="{'color-error': isEDDPending}">
              <svgicon name="question" width="12" height="12" />
              <span v-if="isFilterClosed">{{$t('INDENT_EDD')}}</span>
            </div>
          </Popover>
        </div>
        <!--Update EDD-->

        <!--Gate pass-->
          <div class="link-action"
            v-if="showGatePass && $hasPermission('indent_gate_pass')"
            @click="enableGatePass" v-bind:class="{ 'action-disabled': !isInspectionDone || !isGatePassEnabled }">
            <svgicon name="icon-action-resolve" width="12" height="12" />
            <span>Gate Pass</span>
          </div>
         <!--Gate pass-->

        <!-- DOCUMENT -->
        <div class="d-inline-flex document" v-bind:class="documentClass"
             v-if="!$hasPermission('hide_document_view')"
             @click="$emit('setGA', 'Click', 'Documents')">
          <router-link class="link-action" :to="{ name: 'OrderDetails',
          params: { orderId: order.order_number, category: filter.category},
          query: { isEximRoute: isFromEximListing.toString() }}">
            <svgicon name="documents" width="10" height="10" :original="true" />
            <span v-if="isFilterClosed">{{$t('INDENT_DOCUMENT')}}</span>
          </router-link>
        </div>


        </span>
        <!-- INDENT FROM DRAFT -->
        <div v-else class="link-action">
          <router-link :to="{ name: 'indentDraft',
                  params: { orderId: order.order_number, type: filter.category }}">
            <svgicon name="icon-resolve" width="10" height="10" />
            <span v-if="isFilterClosed">{{$t('INDENT_INDENT')}}</span>
          </router-link>
        </div>
        </div>
      </div>
      <div class="order-col order-actions" v-else-if="isPackingIndentEnabled">
        <div class="ml-auto">
          <!-- MOVE TO DOCK  for HACH-->
          <div class="link-action" v-bind:class="{ 'action-disabled': isActionLoading }"
               v-if="$statusUtil.getStatusId('indented') === order.status"
               v-permission="['ship_ready']"
               @click="onMoveToDock">
            <svgicon name="icon-dock" width="10" height="10" />
            <span>{{$t('INDENT_MOVED_TO_DOCK')}}</span>
          </div>
          <div class="link-action" v-bind:class="{ 'action-disabled': isActionLoading }"
               v-if="$statusUtil.getStatusId('ship_ready') === order.status"
               v-permission="['shipped']"
               @click="onMoveBackIndented">
            <svgicon name="left_arrow" width="10" height="10" />
            <span>{{$t('INDENT_MOVED_BACK_TO_INDENTED')}}</span>
          </div>
          <!-- Handover Complete  for HACH-->
          <div class="link-action" v-bind:class="{ 'action-disabled': isActionLoading }"
               v-if="$statusUtil.getStatusId('ship_ready') === order.status"
               v-permission="['shipped']"
               @click="onHandOverComplete">
            <svgicon name="icon-complete" width="10" height="10" />
            <span>{{$t('INDENT_HANDOVER_COMPLETE')}}</span>
          </div>
          <!-- Handover Complete  for HACH-->
        </div>
      </div>
    </div>
  </div>
  <row
    v-if="!isReturnIndent && hasChildIndents && isExpandView"
    :headers="headers"
    :isReturnIndent="true"
    :order="order.returnIndents"
    :selectedOrder="selectedOrder"
    :configurations="configurations"
    :utilizationStatus="utilizationStatus"
    :movement="movement"
    :deliveryTypes="deliveryTypes"
    :movementTypes="movementTypes"
    :orderType="orderType"
    :userEditPermission="userEditPermission"
    :isFilterClosed="isFilterClosed"
    @showOrder="showOrder"
    @setSelectedAction="setSelectedAction($event, order.id)"
    :subRecursiveFunction="setSelection"
    class="nested-list">
  </row>
</div>
</div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { mapGetters } from 'vuex';
import { groupBy, uniqBy, min } from 'lodash';


// eslint-disable-next-line import/no-extraneous-dependencies
import { importExportType, eximMovementType, eximMovementTypeDetails, legType, orderType, movementType, roles, ApprovalConstants, RFQConstants,
  statusIdDictionary, epodApprovalStatus } from 'pando-constants';
import { orderTypes, InboundType, deliveryPendingReasonsMapping, Menu, indentActions } from '@/constants/order';
import { transportationModeList } from '@/constants/mdm-v2/shipmethod';
import Route from '../Route';
import MarkAsDelivered from '../actions/MarkAsDelivered';
import UpdateEdd from '../actions/UpdateEdd';
import ContainerPickup from '../actions/ContainerPickup';
import EmptyContainerReturned from '../actions/EmptyContainerReturned';
import EwayBill from '../actions/EwayBill';
import StartLoading from '../actions/StartLoading';
import LoadingAtGate from '../actions/LoadingAtGate';
import EndLoading from '../actions/EndLoading';
import AddDocks from '../actions/AddDocks';
import HyperTrack from '../actions/HyperTrack';
import Track from '../actions/Track';
import FreightCharge from '../actions/FreightCharge';
import Quotes from '../actions/Quotes';
import TruckChangeRequest from '../actions/TruckChangeRequest';
import FreightChangeRequest from '../actions/FreightChangeRequest';
import TruckUtilization from '../actions/TruckUtilization';
import EditTruckin from '../actions/EditTruckTimestamp';


export default {
  name: 'row',
  props: {
    order: {
      type: Object,
    },
    selectedOrder: {
      type: String,
    },
    configurations: {
      type: Object,
    },
    utilizationStatus: {
      type: Object,
    },
    movement: {
      type: Object,
    },
    deliveryTypes: {
      type: Object,
    },
    orderType: {
      type: Object,
    },
    movementTypes: {
      type: Object,
    },
    userEditPermission: {
      type: Object,
    },
    isFilterClosed: {
      type: Boolean,
    },
    isEximRoadLeg: {
      type: Boolean,
    },
    isReturnIndent: {
      type: Boolean,
    },
    isFromEximListing: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
    },
    isActionLoading: { // disable action is response got delay hach
      type: Boolean,
      default: false,
    },
    depotConfigDetails: {
      type: Object,
    },
    isVendorDepotUser: {
      type: Boolean,
    },
    vendorDepots: {
      type: Array,
    },
    truckDetainedConfig: {
      type: Object,
    },
    subRecursiveFunction: {
      type: Function,
    },
  },
  components: {
    Route,
    MarkAsDelivered,
    ContainerPickup,
    StartLoading,
    LoadingAtGate,
    EndLoading,
    AddDocks,
    HyperTrack,
    EmptyContainerReturned,
    EwayBill,
    Quotes,
    TruckChangeRequest,
    Track,
    TruckUtilization,
    UpdateEdd,
    FreightCharge,
    EditTruckin,
    FreightChangeRequest,
  },
  data() {
    return {
      isExpandView: false,
      ceilingPrice: 0,
      freightUnit: 0,
      orderTypes,
      InboundType,
      deliveryPendingReasonsMapping,
      truckin: false,
      editTruckin: false,
      containerPickup: false,
      truckout: false,
      emptyContainerReturned: false,
      ewayBill: false,
      markasdelivered: false,
      truckChangeRequest: false,
      showFreightChangeRequestPopup: false,
      startLoading: false,
      addDocks: false,
      endLoading: false,
      startLoadingAtGate: false,
      addFreight: false,
      quotes: false,
      showReindentDialog: false,
      showLrDetails: false,
      showDeliveryNumbers: false,
      truckUtilization: false,
      truckUtilizationDetails: null,
      updateEdd: false,
      isOpen: false,
      epodApprovalStatus,
      sectionType: {
        DEPOT: 1,
        VENDOR: 3,
      },
      options: {
        placement: 'bottom-end',
        modifiers: {
          offset: {
            enabled: true,
            offset: '10,5',
          },
        },
      },
      transportationModeList,
      importExportType,
      eximMovementType,
      Menu,
      indentActions,
      isTruckinTruckoutChanged: this.order.is_truckin_truckout_changed,
      orderDeliveryNumbers: [],
      orderLRDetails: [],
      sob: {
        data: {
          ideal_sob_percentage: '',
          running_sob_percentage: '',
          freight_rate: '',
          freight_unit: '',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      bootstrapData: 'app/bootstrapData',
      orderDetails: 'order/find',
      isOrderLoading: 'order/isOrderLoading',
      docks: 'app/docks',
      hyperTrack: 'order/hyperTrack',
      customFields: 'app/customFields',
      latestUpdated: 'order/latestUpdated',
      filter: 'order/filter',
      currentUser: 'app/currentUser',
      depots: 'app/depots',
      inspectionBeforeTruckin: 'app/inspectionBeforeTruckin',
      eximCustomFields: 'app/eximCustomFields',
      baseFreightAttachmentMandatory: 'indentV2/baseFreightAttachmentMandatory',
      integrationTimeLine: 'order/integrationTimeLine',
      changeTruckComments: 'order/changeTruckComments',
    }),
    hasFreightChangeRequested() {
      return this.order.freight_change_requested &&
        this.order.status === this.$statusUtil.getStatusId('freight_change_requested');
    },
    isLoadingAtSourceEnabled() {
      const config = this.configurations.loading_at_source;
      const movement = this.getMovement.toLowerCase();
      return config && config[movement];
    },
    isLastMileEnabled() {
      return this.$hasFeature('last_mile');
    },
    showLastMileActions() {
      const invalidStatuses = this.$statusUtil.getStatusIds(['indented', 'truck_change_requested', 'indent_rejected',
        'indent_accepted', 'indent_accept_due', 'indent_assign_due', 'requested', 'drafted', 'cancelled']);
      if (this.$hasFeature('reported_at_depot')) {
        invalidStatuses.push(statusIdDictionary.truck_assigned);
      }
      return !invalidStatuses.includes(this.order.status);
    },
    isMarkAsDeliverEnable() {
      if (this.order.movement == movementType.PRIMARY) {
        if (this.$hasPermission('indent_mark_deliver') && this.$hasPermission('mark_as_deliver_primary')) {
          return true;
        }
      }
      if (this.order.movement == movementType.SECONDARY) {
        if (this.$hasPermission('indent_mark_deliver') && this.$hasPermission('mark_as_deliver_secondary')) {
          return true;
        }
      }
      if (this.order.movement == movementType.INWARD) {
        if (this.$hasPermission('inbound_mark_deliver') && this.$hasPermission('mark_as_deliver_vendor')) {
          return true;
        }
      }
      if (this.order.movement == movementType.RETURNS) {
        if (this.$hasPermission('inbound_mark_deliver') && this.$hasPermission('mark_as_deliver_return')) {
          return true;
        }
      }
      return false;
    },
    timeFormat() {
      return (this.bootstrapData &&
        this.bootstrapData.configurations &&
        this.bootstrapData.configurations.is_datepicker_24H_enabled) ? 'DD-MM-yyyy | HH:mm' : 'DD-MM-yyyy | hh:mm A';
    },
    vendorDepotList() {
      return this.vendorDepots && this.vendorDepots.map(depot => depot.id);
    },
    datePickerFormat() {
      return (this.bootstrapData.configurations && this.bootstrapData.configurations.is_datepicker_24H_enabled) ? 'dd-MM-yyyy HH:mm' : 'dd-MM-yyyy hh:mmA';
    },
    isInspectionDone() {
      return this.order &&
        this.order.flow && this.order.flow.inspection && this.order.flow.inspection.accepted;
    },
    isEximImport() {
      return this.order && this.order.exim_type === this.importExportType.IMPORT;
    },
    isLCLMovement() {
      return this.order && this.order.master_indent_movement_type === this.eximMovementType.LCL;
    },
    hasTruckinPending() {
      const accessibleSourcesList = this.order.sources.filter(this.hasDepotGateAccess);
      return accessibleSourcesList.some(source => source.arrived_at === null);
    },
    showTruckIn() {
      return this.isMasterIndentActionCompleted &&
          this.hasTruckinPending &&
            !this.showContainerBooked && ((this.order.status === 5 && this.insideGate) ||
          (([4, 22, 24].includes(this.order.status) &&
          this.$hasFeature('reported_at_depot') &&
          this.order.reported_at)) ||
          ([4, 22, 26].includes(this.order.status) && !this.$hasFeature('reported_at_depot'))
          || ((this.order.status === 4) && this.$hasPermission('special_truck_in')));
    },
    isAirMovement() {
      const orderMovementType = this.order && this.order.master_indent_movement_type;
      const movementDetails = eximMovementTypeDetails.find(type => type.id === orderMovementType);
      return movementDetails && movementDetails.group_type === legType.AIR;
    },
    showEmptyContainerReturned() {
      const hasEmptyContainerReturned = this.order && this.order.custom_fields &&
        this.order.custom_fields.empty_container_fields &&
          this.order.custom_fields.empty_container_fields.empty_container_returned_at;
      return !this.isAirMovement && !this.isLCLMovement && this.$hasPermission('indent_empty_container_return') &&
        this.$statusUtil.getStatusIds(['delivery_pending', 'delivered']).includes(this.order.status) &&
        this.isEximImport && !hasEmptyContainerReturned;
    },
    showContainerBooked() {
      return this.order && this.order.container_id &&
        [4, 22].includes(this.order.status) && this.order.status !== 26 && !this.isEximImport
          && !this.isLCLMovement && !this.isAirMovement;
    },

    hasChildIndents() {
      return this.order && this.order.child_indent_ids && this.order.child_indent_ids.length;
    },

    isRoundTrip() {
      return this.hasChildIndents || this.isReturnIndent;
    },

    getSourcesVehReqDate() {
      if (this.order && this.order.sources && this.order.sources.length) {
        const loadingDates = this.order.sources.map(_obj => _obj.loading_date) || [];
        return min(loadingDates);
      }
      return '';
    },
    getReindentClass() {
      return this.hideContractedTransporter ? 'modal-medium dialog-wrapper' :
        'modal-large dialog-wrapper';
    },
    isReturnVendor() {
      return Object.values(this.InboundType).includes(this.order && this.order.order_sub_type);
    },
    isSimTrackingAllowed() {
      const movement = this.getMovement.toLowerCase();
      return (this.configurations && this.configurations.track_settings &&
      this.configurations.track_settings[movement].enable_sim_tracking) || false;
    },
    enableTruckIn() {
      let truckInCan = true;
      let reason = '';
      if (this.inspectionBeforeTruckin && !this.isEximImport) {
        truckInCan = this.order.flow.inspection.accepted || false;
        reason = 'Inspection Pending/Rejected';
      } if (this.$hasPermission('special_truck_in')) {
        reason = '';
        truckInCan = true;
      }
      if (this.$hasFeature('truck_weights') && !this.order.tare_weight && this.order.tare_weight !== 0) {
        truckInCan = false;
        reason = this.$t('INDENT_WEIGHT_TRUCK_IN_REASON');
      }

      return {
        enabled: truckInCan,
        reason,
      };
    },
    getBackDateConfig() {
      return this.configurations && this.configurations.back_date_config ?
        this.configurations.back_date_config : {};
    },
    yetToTruckIn() {
      return this.order.sources.every(source => source.arrived_at === null);
    },
    yetToDispatch() {
      return this.order.sources.every(source => source.dispatched_at === null);
    },
    hasTruck() {
      return (this.order.vehicle && this.order.vehicle.number) || false;
    },

    simTrackingEnabled() {
      return this.order.flow.sim_tracking && this.order.flow.sim_tracking.is_enabled;
    },

    appTrackingEnabled() {
      return !!(this.order.flow.app_tracking && this.order.flow.app_tracking.track_trip_id);
    },

    hyperTrackingEnabled() {
      return !!(this.order.flow.app_tracking && this.order.flow.app_tracking.embed_url);
    },

    gpsTrackingEnabled() {
      return this.order.flow.gps_tracking && this.order.flow.gps_tracking.is_enabled;
    },

    hasDriverAccepted() {
      return this.order.flow.driver_accepted;
    },
    inspectionDone() {
      const inspectionDate = this.order.flow.inspection && this.order.flow.inspection.inspected_at;
      return this.$hasFeature('truck_inspection') ? Boolean(inspectionDate) : true;
    },
    isPackingIndentEnabled() {
      return this.$hasFeature('packing_indent');
    },
    currentGateHasDocks() {
      const currGate = this.currentGate.gate_id;
      const currGateDocks = this.order.docks.filter(dock => dock.gate_id === currGate);
      return currGateDocks.length > 0;
    },

    orderGates() {
      return this.order.sources && this.order.sources.map(gate => gate.gate_id);
    },
    hasCurrentGateAccess() {
      const source = this.currentGate;
      const associatedGates = (this.currentUser && this.currentUser.gate_associates_ids) &&
        this.currentUser.gate_associates_ids.length;
      return source.type === this.sectionType.DEPOT && associatedGates ?
        this.currentUser.gate_associates_ids.includes(source.gate_id) :
        true;
    },

    hasVendorActionsPermission() {
      if (this.isVendorDepotUser) {
        if (this.vendorDepotList &&
            this.vendorDepotList.length &&
            this.vendorDepotList.includes(this.currentGate.location_id)
        ) {
          return true;
        } return false;
      } return true;
    },

    currentGate() {
      return this.order.sources.find(gate => gate.arrived_at !== null
        && gate.dispatched_at === null);
    },

    hasVendorGateAccess() {
      if (this.currentGate &&
          this.currentGate.location_id &&
          this.vendorDepotList &&
          this.vendorDepotList.length
      ) {
        if (this.vendorDepotList.includes(this.currentGate.location_id.toString())) {
          return true;
        }
      } return false;
    },

    truckReachedFirstLoadingPoint() {
      if (this.$hasFeature('track_first_load_point')) {
        return this.currentGate &&
          this.currentGate.load_point_arrived_at && this.currentGate.load_point_arrived_at !== null;
      }
      return true;
    },

    yetToAddDocks() {
      if (this.currentGateHasDocks) {
        return this.order.docks.filter(
          dock => dock.gate_id === this.currentGate.gate_id).length === 0;
      }
      return false;
    },

    insideGate() {
      const fristCond = this.order.sources
        .some(gate => gate.arrived_at !== null && gate.dispatched_at === null);
      const secondCond = this.order.sources
        .find(gate => gate.arrived_at === null && gate.dispatched_at === null);
      let statusD = true;
      if (fristCond) {
        statusD = false;
      }
      // else if(secondCond){
      //   statusD =  true;
      // }
      return statusD;
    },

    isGatePending() {
      const gates = this.order.sources;
      return gates.some(gate => gate.arrived_at === null);
    },

    isDockToLoadPending() {
      const currentGate = this.currentGate;
      if (!currentGate) {
        return false;
      }
      const docksInGate = this.order.docks.filter(dock => dock.gate_id === currentGate.gate_id);
      return docksInGate.length !== 0 ? docksInGate.some(dock => dock.loading_started_at === null) : false;
    },

    loadingInProgressInDock() {
      const currentGate = this.currentGate;
      if (!currentGate) {
        return false;
      }
      const docksInGate = this.order.docks.filter(dock => dock.gate_id === currentGate.gate_id);
      return docksInGate.some(dock => dock.loading_started_at !== null
        && dock.loading_ended_at === null);
    },

    loadingDoneInGate() {
      if (!this.currentGate) {
        return false;
      }
      const hasGates = (this.currentUser && this.currentUser.gate_associates_ids) &&
        this.currentUser.gate_associates_ids.length;
      let hasGateAccess = true;
      if (this.currentGate.type === this.sectionType.DEPOT && hasGates) {
        hasGateAccess = this.currentUser.gate_associates_ids.includes(this.currentGate.gate_id);
      }
      const isGateLoadingDone = Boolean(this.currentGate.loading_started_at &&
       this.currentGate.loading_ended_at);
      const isDockLoadingDone = (!this.yetToAddDocks) ? (this.order.docks.filter(
        dock => dock.gate_id === this.currentGate.gate_id)
        .every(dock => dock.loading_started_at !== null && dock.loading_ended_at !== null)) : false;
      return hasGateAccess && (isGateLoadingDone || isDockLoadingDone);
    },

    isPartialDispatch() {
      // when multi pickup for an order - at one gate we have loaded and dispatched
      // but another gate it is not dispatched. so in this case still order will be in
      // non-dispatched state. Don't allow to cancel if any one of the gate is in dispatched state.
      return this.order.sources.some(gate => gate.dispatched_at);
    },
    isDispatched() {
      const orderStatus = this.order.status;
      return this.$statusUtil.isDispatched(orderStatus) ||
        this.$statusUtil.isAfterDispatched(orderStatus);
    },

    isArrived() {
      const orderStatus = this.order.status;
      return this.$statusUtil.isTruckArrived(orderStatus) ||
        this.$statusUtil.isAfterTruckArrived(orderStatus) ||
        orderStatus === 17 ||
        orderStatus === 18;
    },
    isDelivered() {
      const orderStatus = this.order.status;
      return this.$statusUtil.isDelivered(orderStatus) ||
        this.$statusUtil.isAfterDelivered(orderStatus) &&
        orderStatus !== this.$statusUtil.getStatusId('container_picked');
    },

    enableCancel() {
      const orderStatus = this.order.status;
      return !(this.isDispatched) ||
        (!this.$statusUtil.isDelivered(orderStatus) &&
          !this.$statusUtil.isCancelled(orderStatus) &&
          this.$hasPermission('override_cancel_indent'));
    },

    documentation() {
      const isLrSubmitted = this.order.is_lr_submitted;
      const isConsignmentNumber = this.order.show_document_based_on_consignment_number;
      const isMaterialSubmitted = this.order.is_material_submitted;
      if (this.configurations && this.configurations.material_invoice_before_truckout &&
      (this.configurations.material_invoice_before_truckout.primary ||
      this.configurations.material_invoice_before_truckout.secondary ||
      this.configurations.material_invoice_before_truckout.vendor ||
      this.configurations.material_invoice_before_truckout.return)) {
        if ((isLrSubmitted || isConsignmentNumber) && isMaterialSubmitted) {
          return true;
        }
        return false;
      }
      return false;
    },

    documentClass() {
      const docStatus = this.documentation;
      if (docStatus) {
        return 'completed';
      }
      return this.order.status === 18 ? 'required' : '';
    },
    showUtilization() {
      if (
        this.getPtlOrFtl !== this.deliveryTypes.FTL &&
        this.order.order_type === this.orderType.NO_FREIGHT
      ) {
        return false;
      }
      if (this.$hasPermission('view_vehicle_utilization')) {
        if ([this.utilizationStatus.PENDING, this.utilizationStatus.REJECTED]
          .includes(this.order.approval_status)) {
          return this.$hasPermission('request_vehicle_utilization') || this.$hasPermission('update_vehicle_utilization');
        } else if ([this.utilizationStatus.PROCESSING].includes(this.order.approval_status)) {
          return this.$hasPermission('approve_vehicle_utilization');
        }
      }
      return false;
    },
    getSvgClassMovement() {
      if (this.order.movement === this.movementTypes.RETURNS) {
        return 'status_return';
      } else if (this.order.movement === this.movementTypes.INWARD) {
        return 'status_vendor';
      } else if (this.order.movement === this.movementTypes.PRIMARY) {
        return 'primary';
      }
      return 'secondary';
    },
    getSvgClassIndent() {
      const orderType = this.orderTypes.find(val => val.id === this.order.order_type);
      return orderType && orderType.iconName;
    },
    isPTLOrder() {
      return this.order.vehicle_type && this.order.vehicle_type.type == this.deliveryTypes.PTL;
    },
    getPtlOrFtl() {
      if (this.order.vehicle_type && this.order.vehicle_type.type == this.deliveryTypes.PTL) {
        return 'PTL';
      }
      return 'FTL';
    },
    getOrderType() {
      const orderType = this.orderTypes.find(val => val.id === this.order.order_type);
      return orderType && orderType.label;
    },
    getMovement() {
      if (this.order.movement === this.movementTypes.RETURNS) {
        return 'Return';
      } else if (this.order.movement === this.movementTypes.INWARD) {
        return 'Vendor';
      } else if (this.order.movement === this.movementTypes.PRIMARY) {
        return 'Primary';
      }
      return 'Secondary';
    },
    truckOutEnable() {
      const permissionList = ['indent_at_load_point', 'indent_start_load', 'indent_end_load'];
      const user = this.currentUser;
      const permissions = user && user.permissions_list;
      let loadingAtGate = this.loadingDoneInGate;
      let enableCheck = false;
      if (this.order.status === 5) {
        enableCheck = !permissionList.filter(val => permissions.includes(val)).length;
        if (permissions.includes('special_truck_out')) {
          enableCheck = true && (!this.insideGate);
          loadingAtGate = true;
        }
      } else if (this.order.status === 18) {
        enableCheck = true;
      }
      if (this.isVendorDepotUser) return enableCheck && loadingAtGate && this.hasVendorGateAccess;
      return enableCheck && loadingAtGate;
    },
    startLoadEnable() {
      const user = this.currentUser;
      const roles = user && user.permissions_list;
      return ['indent_start_load'].filter(val => roles.includes(val)).length;
    },
    isTruckWithMaterialInvoiceEnabled() {
      return this.configurations &&
        this.configurations.material_invoice_before_truckout &&
        this.configurations.material_invoice_before_truckout[this.getMovement.toLowerCase()];
    },

    truckOutDisableCheck() {
      const currentGate = this.currentGate;
      let gateWiseLrCheck = true;
      let enabledTruckOut = true;
      let reason = '';
      if (currentGate && this.isTruckWithMaterialInvoiceEnabled) {
        if (!this.order.allow_truckout) {
          enabledTruckOut = false;
          reason = this.$t('INDENT_MATERIAL_INV_NOT_AVAILABLE');
        }
      }
      if (currentGate && this.$hasFeature('lr_for_truck_out')) {
        const sourceType = currentGate.gate_id ? 'source_gate_id' : 'source_location_id';
        const currentGateType = currentGate.gate_id ? 'gate_id' : 'location_id';

        let consigneeIds = this.order.destinations
          .filter(consignee => consignee[sourceType] === currentGate[currentGateType])
          .map(consignee => consignee.location_id);
        let consigneeHasLr = uniqBy(this.order.lorry_receipt, 'destination_location_id')
          .filter(val => consigneeIds.includes(val.destination_location_id));
        if (this.configurations && this.configurations.multi_drop_at_gate_level) {
          consigneeIds = this.order.destinations
            .filter(consignee => consignee.source_location_id === currentGate.location_id)
            .map((consignee) => {
              if (consignee.gate_id) {
                return `${consignee.location_id}_${consignee.gate_id}`;
              }
              return consignee.location_id;
            });
          consigneeHasLr = uniqBy(this.order.lorry_receipt,
            item => [item.destination_location_id, item.gate_id]);
        }
        gateWiseLrCheck = currentGate.is_lr_updated || consigneeHasLr.length === [...new Set(consigneeIds)].length;
        reason = !gateWiseLrCheck ? this.$t('INDENT_LR_NOT_AVAILABLE') : reason;
        if (this.isEximImport) {
          if (!(this.order && this.order.eway_bill &&
            this.order.eway_bill.ewb_number && this.order.eway_bill.ewb_expiry_date)) {
            gateWiseLrCheck = false;
          }
        }
      }
      if (this.$hasPermission('special_truck_out')) {
        enabledTruckOut = true;
        gateWiseLrCheck = true;
      }
      if (this.order.approval_status && this.$statusUtil.getStatusIds(['loading_ended']).includes(this.order.status)
        && this.filter.category === this.orderType.CONTRACT) {
        if (this.showUtilization) {
          reason = this.$t('VEHICLE_UTILIZATION_NOT_MET');
          enabledTruckOut = false;
        } else if (!this.showUtilization && this.order.approval_status === this.utilizationStatus.PROCESSING) {
          reason = this.$t('VEHICLE_UTILIZATION_IN_PROGRESS');
          enabledTruckOut = false;
        }
      }
      if (this.$hasFeature('truck_weights')) {
        const otherSources = this.order.sources.filter(source => (source.unique_id !== currentGate.unique_id));
        const canTruckLeave = otherSources.every(source => source.dispatched_at !== null);
        if (canTruckLeave) {
          if (!this.order.gross_weight && this.order.gross_weight !== 0) {
            enabledTruckOut = false;
            reason = this.$t('INDENT_WEIGHT_TRUCK_OUT_REASON');
          } else if (enabledTruckOut) {
            enabledTruckOut = true;
            reason = '';
          }
        }
      }

      return { notDisabled: (enabledTruckOut && gateWiseLrCheck), reason };
    },
    // TODO - need to check
    // truckOutDisableCheck() {
    //   const currentGate = this.order.sources.find(gate => gate.arrived_at !== null && gate.dispatched_at === null);
    //   let gateWiseLrCheck = true;
    //   let enabledTruckOut = true;
    //   let reason = '';
    //   if (currentGate && this.isTruckWithMaterialInvoiceEnabled && !this.isEximImport) {
    //     if (!this.order.allow_truckout) {
    //       enabledTruckOut = false;
    //       reason = this.$t('INDENT_MATERIAL_INV_NOT_AVAILABLE');
    //     }
    //   }
    //   if (currentGate && this.$hasFeature('lr_for_truck_out')) {
    //     gateWiseLrCheck = currentGate.is_lr_updated;
    //     reason = !gateWiseLrCheck ? this.$t('INDENT_LR_NOT_AVAILABLE') : reason;

    //     if (this.isEximImport) {
    //       if (!(this.order && this.order.eway_bill &&
    //         this.order.eway_bill.ewb_number && this.order.eway_bill.ewb_expiry_date)) {
    //         gateWiseLrCheck = false;
    //       }
    //     }
    //   }
    //   if (this.$hasPermission('special_truck_out')) {
    //     enabledTruckOut = true;
    //     gateWiseLrCheck = true;
    //   }
    //   if (this.order.approval_status && this.$statusUtil.getStatusIds(['loading_ended']).includes(this.order.status)
    //     && this.filter.category === this.orderType.CONTRACT) {
    //     if (this.showUtilization) {
    //       reason = this.$t('VEHICLE_UTILIZATION_NOT_MET');
    //       enabledTruckOut = false;
    //     } else if (!this.showUtilization && this.order.approval_status === this.utilizationStatus.PROCESSING) {
    //       reason = this.$t('VEHICLE_UTILIZATION_IN_PROGRESS');
    //       enabledTruckOut = false;
    //     }
    //   }
    //   return { notDisabled: (enabledTruckOut && gateWiseLrCheck), reason };
    // },
    autoAssignTransporterConfig() {
      return this.configurations && this.configurations.auto_switch_transporter;
    },
    isOpenRfqEnabled() {
      return this.configurations && this.configurations.open_indent_rfq;
    },
    hideContractedTransporter() {
      let hide = false;
      const config = this.autoAssignTransporterConfig;
      const movement = this.getMovement.toLowerCase();
      const deliveryType = this.getPtlOrFtl.toLowerCase();
      if (config && config[`is_enabled_for_${deliveryType}`] &&
        config[`is_enabled_for_${movement}`]) {
        hide = true;
      }
      if (this.configurations && this.configurations.enable_open_re_indent &&
      this.order.order_type === orderType.OPEN) {
        hide = true;
      }
      return hide;
    },
    isEDDPending() {
      return this.order.destinations.some(val => !val.expected_delivery);
    },
    errorMessage() {
      const error = [];
      const approvalLevels = this.order.approvals_data && this.order.approvals_data.approval_levels;
      const approvalType = this.order.approvals_data && this.order.approvals_data.approval_type;
      const trackTripId = this.order.flow.gps_tracking.track_trip_id ||
        this.order.flow.app_tracking.track_trip_id || this.order.flow.sim_tracking.trip_id;
      const { ApprovalStatus } = RFQConstants;
      const destinations = this.order.destinations;
      const epodApprovalEventStatus = this.order.epod_approval_status;
      if (!this.isPackingIndentEnabled) {
        if (this.order.delivery_pending_reason && this.order.status === 23) {
          error.push(deliveryPendingReasonsMapping[this.order.delivery_pending_reason]);
        }
        if (this.order.auto_deliver && this.order.status === 23 &&
          !([4, 6].includes(this.order.delivery_pending_reason)) &&
          epodApprovalEventStatus === this.epodApprovalStatus.PENDING) {
          error.push('GRN Approval Pending');
        }
        if (this.order.status === 6
          && destinations.some(dest => Object.prototype.hasOwnProperty.call(dest, 'is_cash_collected') && !dest.is_cash_collected)) {
          error.push('COD confirmation pending');
        }
        if (this.order.track_error && ![7, 23].includes(this.order.status)) {
          error.push(this.order.track_error);
        }
        if (this.isEDDPending && ![7, 8].includes(this.order.status)) {
          error.push('EDD unavailable');
        }
        if (this.order.modify_picklist_error) {
          error.push(this.order.modify_picklist_error);
        }
        if (this.isFreightProvisionFailed && this.isDispatched) {
          error.push('Unsuccessful freight provision');
        }
        if (this.order.approval_status !== 1 &&
         this.$statusUtil.isDeliveryPending(this.order.status)) {
          error.push('Utilization Check');
        }
        if (approvalLevels && approvalLevels.length && ![7, 8].includes(this.order.status)) {
          let levels = [];
          if (approvalType === ApprovalConstants.ApprovalFlows.SEQUENTIAL) {
            levels = [`L${approvalLevels.find(_level => _level.status === ApprovalStatus.ACTIVE).level}`];
          } else {
            levels = approvalLevels.filter(_level => _level.status !== ApprovalStatus.APPROVED).map(l => `L${l.level}`);
          }
          error.push(`${levels.toString()} APPROVAL PENDING`);
          return error;
        }
        if (this.order.userRejectionLevel && ![7, 8].includes(this.order.status)) {
          error.push(`L${this.order.userRejectionLevel} APPROVAL REJECTED`);
          return error;
        }
        if (this.order.status === 2) {
          error.push(this.$t('INDENT_TRANSPORTER_REJECTED'));
        }
        const validStatuses = this.$statusUtil.getStatusIds(['truck_assigned', 'truck_arrived', 'dispatched', 'truck_rejected', 'loading_started', 'loading_ended', 'indent_arrived_due', 'reported']);
        const validTrackingType = this.configurations.mobile_tracking_type === 'APP';
        if (validStatuses.includes(this.order.status) && !trackTripId && validTrackingType) {
          error.push(this.$t('INDENT_TRIP_NOT_ACCEPTED'));
        }
      }
      return error;
    },
    isMasterIndentActionCompleted() {
      let response = true;
      if ('master_action_completed' in this.order) {
        // is container Booked status
        response = this.order.master_action_completed;
      }
      return response;
    },
    isFreightProvisionFailed() {
      return this.configurations.payment_settings &&
      this.configurations.payment_settings.retry_freight_provision &&
      this.order.allow_retry_freight_provision;
    },
    modeOfTransporterIcon() {
      const modeOfTransporter = this.order.ship_pack_details && this.order.ship_pack_details.mode_of_transport;
      const modeOfTransportDetails = this.transportationModeList && this.transportationModeList.find(val => val.name === modeOfTransporter);
      return modeOfTransportDetails && modeOfTransportDetails.iconName;
    },
    isTruckInBackDateAllowed() {
      return !!(this.configurations && this.configurations.truck_in_allow_back_date);
    },
    showGatePass() {
      const outboundConstant = this.Menu.find(val => val.name === 'Outbound');
      if (this.filter.category === outboundConstant.id &&
        this.order && this.showTruckIn && this.depotConfigDetails) {
        const depotConfig = this.depotConfigDetails.gate_pass_applicable;
        return depotConfig && !this.order.gate_pass;
      }
      return false;
    },
    isGatePassEnabled() {
      const outboundConstant = this.Menu.find(val => val.name === 'Outbound');
      if (this.filter.category === outboundConstant.id &&
        this.order && this.showTruckIn) {
        return this.$hasPermission('indent_gate_pass');
      }
      return false;
    },
    typeOfIndent() {
      switch (this.order.movement) {
        case movementType.SECONDARY:
          return 'mark_as_deliver_secondary';
        case movementType.PRIMARY:
          return 'mark_as_deliver_primary';
        case movementType.INWARD:
          return 'mark_as_deliver_vendor';
        case movementType.RETURNS:
          return 'mark_as_deliver_return';
      }
    },
  },

  methods: {
    assignTruck() {
      this.$emit('setGA', 'Click', 'Vehicle');
      this.setSelectedAction(this.indentActions.ASSIGN_TRUCK);
    },
    async handleDN() {
      this.$emit('setGA', 'Click', 'DN');
      try {
        const orderNo = this.order.order_number;
        const result = await this.$store.dispatch('order/getDeliveryNumbers', { orderNo });
        if (result && result.length) {
          this.orderDeliveryNumbers = result;
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async getLRDetails() {
      this.$emit('setGA', 'Click', 'LR Numbers');
      try {
        const orderId = this.order.id;
        const result = await this.$store.dispatch('order/getLRDetails', { orderId });
        if (result && result.length) {
          this.orderLRDetails = result;
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async markAsDelivered() {
      if (!this.subRecursiveFunction) {
        this.setSelectedAction(this.indentActions.MARK_AS_DELIVERED);
        await this.fetchOrder();
      } else {
        this.subRecursiveFunction(this.indentActions.MARK_AS_DELIVERED);
        await this.fetchOrder();
      }
    },
    setSelection(action) {
      this.$emit('setSelectedAction', action);
    },
    setSelectedAction(actionName) {
      this.getOrderDetails(actionName);
      this.setSelection(actionName);
      if (actionName === 'RE_INDENT') {
        const freightUnitFromBaseFreight = (this.order && this.order.base_frieght
          && this.order.base_frieght.freight_unit) || 0;
        this.$emit('set-reindent-info', {
          ceilingPrice: this.ceilingPrice,
          freightUnit: freightUnitFromBaseFreight,
          deliveryTypes: this.deliveryTypes,
        });
      }
    },
    hasDepotGateAccess(source) {
      const hasGateAccess = (this.currentUser && this.currentUser.gate_associates_ids) && this.currentUser.gate_associates_ids.length;
      if (this.currentUser.role.type === roles.VENDOR_GATE_MANAGER) {
        const hasVendorGateAcess = this.order.sources.filter(val => (this.vendorDepotList.includes(val.location_id)
         && !val.arrived_at && !val.dispatched_at));
        return !!((source.type === this.sectionType.VENDOR) && hasVendorGateAcess.length);
      }
      return source.type === this.sectionType.DEPOT && hasGateAccess ? this.currentUser.gate_associates_ids.includes(source.gate_id) : true;
    },
    rowLabel(order, label) {
      let labelValue = order[label.data.key];
      if (label.data.view_rule) {
        labelValue = label.data.view_rule(order[label.data.key]);
        if (label.data.key === 'sources') {
          labelValue = label.data.view_rule(order[label.data.key], this.timeFormat);
        }
      }
      return labelValue;
    },
    getClass(columnClass) {
      return columnClass.toString();
    },
    getSourceDetails(sources) {
      const source = sources.length ? sources[0] : {};
      return source.type === 1 ? this.$depot.depotOthers(source.location_id) : source.details;
    },
    getRoute() {
      return this.isReturnVendor && `${this.order.depotDetails.city} - ${this.order.consignees[0].city}`;
    },
    closeFreightPop() {
      this.addFreight = false;
    },
    closeTruckTimestampUpdate(isTruckinUpdated) {
      this.isTruckinTruckoutChanged = isTruckinUpdated;
      this.editTruckin = false;
    },
    async enableGatePass() {
      try {
        if (this.isInspectionDone) {
          const id = this.order.order_number;
          const result = await this.$store.dispatch('order/enableGatePass', { id });
          if (result.order_number) {
            this.$success({
              message: this.$t('GATE_PASS_SUCCESS_MSG', { order_number: result.order_number }),
            });
          } else if (result.status === 400) {
            const { errors: [error] } = result.data;
            if (error) {
              this.$error({
                message: `${error.message}, ${id}`,
              });
            }
          } else {
            this.$error({
              message: this.$t('GATE_PASS_ERROR_MSG', { order_number: result.order_number }),
            });
          }
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    showQuotes() {
      if (!this.$hasFeature('request_for_quote') && this.order.status !== 25) {
        return false;
      }
      let validStatusIds = [1, 2, 3, 4, 16, 20, 21, 22, 25];
      const { CONTRACT, MARKET, OPEN } = this.orderType;
      const validOrderTypes = [CONTRACT, MARKET];
      if (this.isOpenRfqEnabled) {
        validOrderTypes.push(OPEN);
      }
      // [0,3,1];
      if (this.$hasPermission('override_reindent')) {
        validStatusIds = validStatusIds.concat([0, 3, 16]);
      }
      return this.order.has_quote &&
        validStatusIds.includes(this.order.status) &&
        validOrderTypes.includes(this.order.order_type);
    },
    addFreightAmount() {
      this.$emit('setGA', 'Click', 'Freight payment');
      this.setSelectedAction('FREIGHT');
    },
    showReindent() {
      const orderStatus = this.order.status;
      if (!this.$hasPermission('reindent')) {
        return false;
      }

      if (this.order.order_type !== this.orderType.CONTRACT &&
       this.order.order_type !== this.orderType.MARKET &&
       (this.configurations && !this.configurations.enable_open_re_indent &&
        this.order.order_type === this.orderType.OPEN)) {
        return false;
      }

      let statusCheck;
      if (this.$hasFeature('reported_at_depot')) {
        statusCheck = [0, 1, 2, 3, 4, 16, 20, 21, 22, 24].includes(orderStatus);
      } else {
        statusCheck = this.$statusUtil.isBeforeTruckArrived(orderStatus);
      }

      if (this.configurations && this.configurations.enable_open_re_indent &&
        this.order.order_type === this.orderType.OPEN && statusCheck) {
        if (this.order.rfq_accepted) {
          return false;
        }
        return true;
      }

      if (this.$hasPermission('override_reindent') && statusCheck) {
        return true;
      }
      if (this.$hasFeature('request_for_quote')) {
        if (this.order.sla_breach || this.order.acceptance_sla_breach) {
          return !this.order.has_quote && [1, 2, 3, 4, 16, 20, 21, 22].includes(orderStatus);
        }
        return !this.order.has_quote && [2, 16, 25].includes(orderStatus);
      }

      return [2, 20, 21, 22, 16].includes(orderStatus);
    },
    changeCeilingPrice(value) {
      this.ceilingPrice = value;
    },
    toggleReindent(rfqData) {
      this.showReindentDialog = true;
      this.ceilingPrice = (rfqData && rfqData.ceiling_price) || 0;
      this.freightUnit = (rfqData && rfqData.quotes[0].freight_unit) || 0;
    },
    statusName(id) {
      const mainStatus = this.$statusUtil.mainStatus;
      const mainStatusId = this.$statusUtil.getMainStatusId(id);
      return mainStatus.find(status => status.id === mainStatusId) &&
        mainStatus.find(status => status.id === mainStatusId).tlabel;
    },

    async enableSimTracking() {
      try {
        const id = this.order.order_number;
        const result = await this.$store.dispatch('order/track', { id });
        if (result.order_number) {
          this.$success({
            message: this.$t('INDENT_TRACKING_SUCCESS_MSG', { order_number: result.order_number }),
          });
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async resendsms(phone) {
      try {
        const result = await this.$store.dispatch('order/sendconsent', { phone });
        if (result) {
          this.$success({
            message: this.$t('INDENT_CONSENT_SUCCESS_MSG', { phone }),
          });
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    getConsignee(gate) {
      const consignees = this.orderDetails.destinations;
      const gateId = gate.gate_id;
      return consignees.filter(consignee => gateId === consignee.gate_id);
    },

    async truckReported() {
      try {
        const hasConfirm = await this.$PromptConfirm(this.$t('INDENT_TRUCK_REPORT_CONFIRMATION'), this.$t('INDENT_TRUCK_REPORTING'), {
          confirmButtonText: this.$t('INDENT_YES'),
          cancelButtonText: this.$t('INDENT_NO'),
          lockScroll: true,
          showClose: false,
          center: true,
          dangerouslyUseHTMLString: true,
        });
        if (hasConfirm === 'confirm') {
          const orderNo = this.order.order_number;
          const result = await this.$store.dispatch('order/truckReportedAt', { orderNo, ptlGroupId: this.order.ptl_group_id });
          if (result && result.data && result.data.order_number) {
            this.$success({
              message: this.$t('INDENT_REPORTED_SUCCESS_MSG', { order_number: result.data.order_number }),
            });
          } else if (result && result.error) {
            this.$error({ message: result.error });
          } else if (result.message && result.message === 'PTL_GROUP_ACTION_PROGRESS') {
            this.$success({ message: this.$t(result.message) });
          } else if (result.message) {
            this.$error({ message: this.$t(result.message) });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    async onLoadStartAtGate() {
      try {
        if (!this.subRecursiveFunction) {
          this.setSelectedAction(this.indentActions.START_LOAD);
          await this.fetchOrder();
        } else {
          this.subRecursiveFunction(this.indentActions.START_LOAD);
          await this.fetchOrder();
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async onLoadEndAtGate() {
      try {
        if (!this.subRecursiveFunction) {
          this.setSelectedAction(this.indentActions.END_LOAD);
          await this.fetchOrder();
        } else {
          this.subRecursiveFunction(this.indentActions.END_LOAD);
          await this.fetchOrder();
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async onLoadTruckIn() {
      try {
        if (!this.subRecursiveFunction) {
          this.setSelectedAction(this.indentActions.TRUCKIN);
          await this.fetchOrder();
        } else {
          this.subRecursiveFunction(this.indentActions.TRUCKIN);
          await this.fetchOrder();
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async onLastMileActions() {
      try {
        if (!this.subRecursiveFunction) {
          this.setSelectedAction(this.indentActions.LAST_MILE_ACTIONS);
          await this.fetchOrder();
        } else {
          this.subRecursiveFunction(this.indentActions.LAST_MILE_ACTIONS);
          await this.fetchOrder();
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async onReachedFirstLoadingPoint() {
      try {
        const id = this.order.order_number;
        const result = await this.$store.dispatch('order/reachedFirstLoadingPoint', {
          id,
          unique_id: this.currentGate.unique_id,
          ptlGroupId: this.order.ptl_group_id,
        });
        if (result && result.data && result.data.order_number) {
          // at gate name
          this.$success({
            message: this.$t('INDENT_VEHICLE_REACH_SUCCESS_MSG', { order_number: result.data.order_number }),
          });
        } else if (result && result.message && result.message === 'PTL_GROUP_ACTION_PROGRESS') {
          this.$success({ message: this.$t(result.message) });
        } else if (result && result.message) {
          this.$errorMessage({ message: this.$t(result.message) });
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async truckOut() {
      try {
        const order = await this.$store.dispatch('order/find', this.order.order_number);
        const {
          order_number: id,
        } = order;
        const data = {};
        data.gate_id = this.currentGate.id;
        data.dispatched_at = new Date();
        const result = await this.$store.dispatch('order/truckout', {
          id,
          data,
          ptlGroupId: this.order.ptl_group_id,
        });
        if (result && result.data && result.data.order_number) {
          this.$success({
            message: this.$t('INDENT_VEHICLE_REACH_SUCCESS_MSG', { order_number: result.data.order_number }),
          });
        } else if (result && result.message && result.message === 'PTL_GROUP_ACTION_PROGRESS') {
          this.$success({ message: this.$t(result.message) });
        } else if (result && result.message) {
          this.$error({ message: this.$t(result.message) });
        }
        if (!this.subRecursiveFunction) {
          this.setSelectedAction(this.indentActions.TRUCKOUT);
          await this.fetchOrder();
        } else {
          this.subRecursiveFunction(this.indentActions.TRUCKOUT);
          await this.fetchOrder();
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    getQuotes() {
      const { id } = this.order;
      if (!this.isEximRoadLeg) {
        this.$store.dispatch('order/getRfq', this.order.order_number);
        this.loadData('rfq');
      }
      this.$emit('showOrder', id, this.indentActions.QUOTES);
    },
    getOrderDetails(actionName) {
      const { id } = this.order;
      this.$emit('getPtl', { order: this.order, actionName });
      this.loadData();
      if (this.$hasFeature('packing_indent')) {
        this.$store.commit('order/INIT_SUB_DELIVERY_DETAILS');
        this.getPackingDetails(this.order.order_number);
      }
      // this.$store.dispatch('order/documentationList', this.order.order_number);
      this.$emit('getBaseFreight', this.order);
      if (this.selectedOrder === id) {
        this.$emit('showOrder', null);
        return;
      }
      this.$emit('showOrder', id);
      this.$emit('setGA', 'Click', 'Expand Indent Card');
      if (this.order) {
        const weights = {
          tare_weight: this.order.tare_weight,
          gross_weight: this.order.gross_weight,
        };
        this.$emit('showWeights', weights);
      }
    },
    loadData(type) {
      if (!this.isEximRoadLeg) {
        if (type !== 'find') this.$store.dispatch('order/find', this.order.order_number);
        if (type !== 'rfq') this.$store.dispatch('order/getRfq', this.order.order_number);
        if (type !== 'cancelRemarks') this.$store.dispatch('order/getCancelRemarks', this.order.order_number);
        if (type !== 'orderHistory') this.$store.dispatch('order/getOrderHistory', this.order.order_number);
        this.$store.dispatch('order/getIntegrationTimeLine', this.order.order_number);
        if (this.order.change_vehicle_type_id) {
          this.$store.dispatch('order/truckChangeComment', this.order.order_number);
        }
      }
    },
    async getPackingDetails(orderId) {
      try {
        if (this.$hasFeature('packing_indent')) {
          const result = await this.$store.dispatch('order/getPackingDetailsSummary', orderId);
          if (!result) {
            this.$errorMessage({ message: this.$t('GENERAL ERROR') });
          } else if (result && result.error) {
            this.$errorMessage({ message: result.error });
          }
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    showOrder(data) {
      this.$emit('showOrder', data);
    },
    getStatus(id) {
      return `order-status-${this.$statusUtil.getMainStatusName(id)}`;
    },

    async fetchOrder() {
      try {
        const orderNum = this.order.order_number;
        await this.$store.dispatch('order/vehicleFind', orderNum);
        if (!this.yetToTruckIn && !this.simTrackingEnabled) {
          await this.$store.dispatch('order/hyperTrack', orderNum);
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    hide(type) {
      this.$set(this, type, false);
    },
    async getComments() {
      try {
        const orderNo = this.order.order_number;
        await this.$store.dispatch('order/truckChangeComment', orderNo);
        if (this.$hasFeature('show_sob_utilization_details')) {
          let maxFreightContractId = null;
          let maxFreightCharge = 0;
          if (this.order.destinations && this.order.destinations.length > 0) {
            this.order.destinations.forEach((destination) => {
              if (destination.contract && destination.contract.freight_charges > maxFreightCharge) {
                maxFreightCharge = destination.contract.freight_charges;
                maxFreightContractId = destination.contract.id;
              }
            });
            this.sob = await this.$store.dispatch('order/shareOfBusiness', {
              orderNo,
              contractId: maxFreightContractId,
            });
          }
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async acceptFreightChangeRequest() {
      try {
        const orderNo = this.order.order_number;
        await this.$store.dispatch('order/acceptFreightChangeRequest', orderNo);
        this.hide('showFreightChangeRequestPopup');
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async rejectFreightChangeRequest() {
      try {
        const orderNo = this.order.order_number;
        await this.$store.dispatch('order/rejectFreightChangeRequest', orderNo);
        this.hide('showFreightChangeRequestPopup');
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async acceptTruckRequest() {
      try {
        const orderNo = this.order.order_number;
        await this.$store.dispatch('order/indentTruckChangeAccept', orderNo);
        this.hide('truckChangeRequest');
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async denyTruckChangeRequest() {
      try {
        const orderNo = this.order.order_number;
        await this.$store.dispatch('order/denyTruckChangeRequest', orderNo);
        this.hide('truckChangeRequest');
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async getUtilization() {
      try {
        const { order_number: orderNo } = this.order;
        const response = await this.$store.dispatch('order/getVehicleUtilization', orderNo);
        this.truckUtilizationDetails = response;
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    toggleExpandView(e) {
      e.stopPropagation();
      if (this.isExpandView) { // to be changed to false
        this.isExpandView = false;
      } else { // to be changes to true
        this.fetchReturnIndents();
      }
    },
    async fetchReturnIndents() {
      try {
        const { order_number: orderNo } = this.order;
        const params = {
          indent_id: this.order.child_indent_ids[0],
        };
        const response = await this.$store.dispatch('order/getReturnIndents', { masterOrderId: this.order.order_number, params });
        if (response && response.error) {
          this.$error({ message: response.error });
        } else {
          this.isExpandView = true;
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async onMoveToDock() {
      try {
        this.isActionLoading = true;
        const response = await this.$store.dispatch('order/moveToDock', this.order.order_number);
        if (response && response.error) {
          this.$error({ message: response.error });
        } else {
          this.$success({
            message: this.$t('INDENT_MOVE_TO_DOCK_SUCCESS_MSG', { order_number: this.order.order_number }),
          });
        }
        this.isActionLoading = false;
      } catch (error) {
        this.isActionLoading = false;
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async onHandOverComplete() {
      try {
        this.isActionLoading = true;
        const response = await this.$store.dispatch('order/handOverComplete', this.order.order_number);
        if (response && response.error) {
          this.$error({ message: response.error });
        } else {
          this.$success({
            message: this.$t('INDENT_HANDOVER_COMPLETE_SUCCESS_MSG', { order_number: this.order.order_number }),
          });
        }
        this.isActionLoading = false;
      } catch (error) {
        this.isActionLoading = false;
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async onMoveBackIndented() {
      try {
        this.isActionLoading = true;
        const response = await this.$store.dispatch('order/moveBackToIndented', this.order.order_number);
        if (response && response.error) {
          this.$error({ message: response.error });
        } else {
          this.$success({
            message: this.$t('INDENT_MOVED_BACK_TO_INDENTED_MSG', { order_number: this.order.order_number }),
          });
        }
        this.isActionLoading = false;
      } catch (error) {
        this.isActionLoading = false;
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@common/styles-shipper/settings";

.datelabel,.text-secondary {
  display: block;
  font-family: $fontRegular;
  font-size: 12px;
  color: #737373;
  padding: 7px 0 0 0;
}

.max-height {
  max-height: 400px !important;
}

.tab-remove {
    right: 40px;
    position: absolute;
    text-align: right;
    width: 100%;
    top: 39px;
    cursor: pointer;
}
.order-item{
  .order {
      &-status{
        height: 45px;
      }
  }
}
.nested-list {
  .order-row {
    padding-left: 20px !important;
  }
}
.order {
    &-status-button {
        margin-top: -10px;
        padding: 2px 5px 0px 5px;
        border-radius: 2px;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 0px;
        font-family:$fontSemibold;
        text-transform: uppercase;
        width: fit-content;
        height: 20px;
        &_ps{
          padding: 4px 5px 3px;
          border-radius: 2px;
          margin-left: -6px;
          margin-right: -6px;
          text-align: center;
            .el-tooltip{
                background: transparent;
                border: transparent;
            }
          .svg-fill{
            margin-top: 0px;
          }
        }
    }
    &-item {
        margin-bottom: 10px;
        box-shadow: 0 2px 4px 0 #ECECEC;

        .order-row {
            width: 100%;
            padding: 0 10px 0 30px;
            background: #fff;
            //display: flex;
            &:hover {
              background-color: #eff3f5;
            }
            &.overdue {
                /*background: rgba(255, 0, 0, 0.1);*/
            }
        }

        .order-col {
            display: flex;
            align-items: center;
            padding: 10px 10px 10px 0px;
            font-family:$fontSemibold;
            color: #404040;
        }

        .order-details {
            position: relative;
            padding: 16px;
            background: #fff;
            border-top: 1px solid #F0F0F0;
        }
    }

    &-input-title {
        @extend %normal;
        color: $sec-text;
        font-size: 1.2rem;
        text-transform: uppercase;
    }

    &-input-value {
        font-family:$fontSemibold;
        color: $sec-text;
        border-bottom: 1px solid #DEE5E6;
        font-size: 1.2rem;
        padding: 10px 0 5px;
    }

    &-status {
        &-indented {
            .order-status-button {
                border: 1px solid rgba(237, 226, 254, 0.7);
                background-color: rgba(237, 226, 254, 0.7);
                color: $intented;
                &_ps{
                  background-color: rgba(237, 226, 254, 0.3);
                  color: $intented;
                  .svg-fill{
                    fill: $intented;
                  }
                }
            }
        }
        &-truck_assigned {
            .order-status-button {
                border: 1px solid rgba(255, 220, 229, 0.7);
                background-color: rgba(255, 220, 229, 0.7);
                color: $assigned;
                &_ps{
                  background-color: rgba(255, 220, 229, 0.3);
                  color: $assigned;
                  .svg-fill{
                    fill: $assigned;
                  }
                }
            }
        }
        &-truck_arrived {
            .order-status-button {
                border: 1px solid rgba(178, 235, 242, 0.7);
                background-color: rgba(178, 235, 242, 0.7);
                color: $arrived;
                &_ps{
                  background-color: rgba(178, 235, 242, 0.3);
                  color: $arrived;
                  .svg-fill{
                    fill: $arrived;
                  }
                }
            }
        }
        &-shipped {
            .order-status-button {
                border: 1px solid rgba(207, 223, 255, 0.7);
                background-color: rgba(207, 223, 255, 0.7);
                color: $dispatched;
                &_ps{
                  background-color: rgba(207, 223, 255, 0.3);
                  color: $dispatched;
                  .svg-fill{
                    fill: $dispatched;
                  }
                }
            }
        }
        &-ship_ready {
            .order-status-button {
                border: 1px solid rgba(178, 235, 242, 0.7);;
                background-color: rgba(178, 235, 242, 0.7);;
                color: $arrived;
                &_ps{
                  background-color: rgba(178, 235, 242, 0.3);
                  color: $arrived;
                  .svg-fill{
                    fill: $arrived;
                  }
                }
            }
        }
      &-re_ship {
        .order-status-button {
          border: 1px solid rgba(231, 231, 231, 0.7);;
          background-color: rgba(231, 231, 231, 0.7);;
          color: $arrived;
          &_ps{
            background-color: rgba(231, 231, 231, 0.3);
            color: $arrived;
            .svg-fill{
              fill: $arrived;
            }
          }
        }
      }
       &-re_ship_processing {
        .order-status-button {
          border: 1px solid rgba(231, 231, 231, 0.7);;
          background-color: rgba(231, 231, 231, 0.7);;
          color: $arrived;
          &_ps{
            background-color: rgba(231, 231, 231, 0.3);
            color: $arrived;
            .svg-fill{
              fill: $arrived;
            }
          }
        }
      }
        &-dispatched {
            .order-status-button {
                border: 1px solid rgba(207, 223, 255, 0.7);
                background-color: rgba(207, 223, 255, 0.7);
                color: $dispatched;
                &_ps{
                  background-color: rgba(207, 223, 255, 0.3);
                  color: $dispatched;
                  .svg-fill{
                    fill: $dispatched;
                  }
                }
            }
        }
        &-delivered {
            .order-status-button {
                border: 1px solid rgba(208, 247, 197, 0.7);
                background-color: rgba(208, 247, 197, 0.7);
                color: $delivered;
                &_ps{
                  background-color: rgba(208, 247, 197, 0.3);
                  color: $delivered;
                  .svg-fill{
                    fill: $delivered;
                  }
                }
            }
        }
        &-delivery_pending {
            .order-status-button {
                border: 1px solid rgba(208, 247, 197, 0.7);
                background-color: rgba(208, 247, 197, 0.7);
                color: $delivery_pending;
                &_ps{
                  background-color: rgba(208, 247, 197, 0.3);
                  color: $delivery_pending;
                  .svg-fill{
                    fill: $delivery_pending;
                  }
                }
            }
        }
        &-cancelled {
            .order-status-button {
                border: 1px solid rgba(255, 230, 234, 0.7);
                background-color: rgba(255, 230, 234, 0.7);
                color: $canceled;
                &_ps{
                  background-color: rgba(255, 230, 234, 0.3);
                  color: $canceled;
                  .svg-fill{
                    fill: $canceled;
                  }
                }
            }
        }
        &-optima_suggested {
          .order-status-button {
                border: 1px solid rgba(255, 230, 234, 0.7);
                background-color: rgba(255, 230, 234, 0.7);
                color: $canceled;
                &_ps{
                  background-color: rgba(255, 230, 234, 0.3);
                  color: $canceled;
                  .svg-fill{
                    fill: $canceled;
                  }
                }
            }
        }
         &-re_ship_error {
            .order-status-button {
                border: 1px solid rgba(255, 230, 234, 0.7);
                background-color: rgba(255, 230, 234, 0.7);
                color: $canceled;
                &_ps{
                  background-color: rgba(255, 230, 234, 0.3);
                  color: $canceled;
                  .svg-fill{
                    fill: $canceled;
                  }
                }
            }
        }
        &-requested {
            .order-status-button {
                border: 1px solid rgba(255, 240, 203, 0.7);
                background-color: rgba(255, 240, 203, 0.7);
                color: $requested;
                &_ps{
                  background-color: rgba(255, 240, 203, 0.3);
                  color: $requested;
                  .svg-fill{
                    fill: $requested;
                  }
                }
            }
        }
        &-container_picked{
            .order-status-button{
                border: 1px solid rgba(178, 235, 242, 0.7);
                background-color: rgba(178, 235, 242, 0.7);
                color: $arrived;
              &_ps{
                  background-color: rgba(178, 235, 242, 0.3);
                  color: $arrived;
                  .svg-fill{
                    fill: $arrived;
                  }
                }
            }
          }
        &-drafted {
            .order-status-button {
                border: 1px solid rgba(231, 231, 231, 0.3);
                background-color: rgba(231, 231, 231, 1);
                color: $drafted;
                &_ps{
                  background-color: rgba(231, 231, 231, 0.3);
                  color: $drafted;
                  .svg-fill{
                    fill: $drafted;
                  }
                }
            }
        }
    }
}

.tab {
    &__wrapper {
        > ul {
            @extend %clearfix;
            margin: 0;
            padding: 0;
            border-bottom: 1px solid #f0f0f0;

            li {
                list-style-type: none;
                float: left;
                padding: 6px 0 8px;
                font-family:$fontSemibold;
                font-size: 1.6rem;
                color: $primary-text;
                opacity: 0.3;
                cursor: pointer;
                margin: 0 40px 0 0;
                &.tab__active {
                    opacity: 1;
                    border-bottom: 2px solid #6595CA;
                }
            }
        }
    }
    &__content {
        padding: 20px 0 0;
    }
}

.order {
  &-list-wrapper {
    min-height: 700px;
    padding-top: 50px;
  }
  &-row {
    display: flex;
  }
  &-col {
    font-size: 1.2rem;
  }
  &-id {
    width: 175px;
    padding-left: 12px;
  }
  &-date {
    width: 100px;
  }
  &-status {
    width: 140px;
  }
  &-route {
    width: 200px;
    cursor: pointer;
  }
  &-vendor {
    width: 150px;
    // &.vendor-lg {
    //   width: 270px;
    // }
  }
  &-truck {
    width: 160px;
  }
  &-shipment {
    width: 150px;
  }
  &-actions {
    width: auto !important;
    margin-left: auto !important;
  }
  &-accordion-btn {
    width: 30px;
    text-align: center;
    cursor: pointer;
  }
}

.order-sec-action {
    text-align: right;
    &.for-order {
        position: absolute;
        right: 18px;
        top: 30px;
    }
    ul {
        @extend %list-unstyled;
        li {
            @extend %semi-bold;
            padding-left: 16px;
            cursor: pointer;
            display: inline-block;
            font-size: 1.2rem;
            color: $primary-text;
            text-transform: uppercase;
            @extend %bold;
        }
    }
}

.order-actions {
    text-align: right;
    .action {
        display: inline-block;
        font-family:$fontSemibold;
        font-size: 1.2rem;
        color: $primary-text;
        cursor: pointer;
        text-transform: uppercase;
        padding: 0 5px;
        a {
            color: $primary-text;
            text-decoration: none;
        }
        > span {
            display: inline-block;
        }
    }
    .action-disabled {
        color: #a09d9d;
        svg path{
          color: #a09d9d;
          stroke: #a09d9d;
        }
    }
}

.document {
    &.completed {
        a,
        svg g {
            color: #91C38A;
            stroke: #91C38A;
        }
    }
    &.required {
        a,
        svg g {
            color: #E25757;
            stroke: #E25757;
        }
    }
}
.custom-fields {
    margin-bottom: 10px;
    width: 150px;

    label {
        display: block;
    }
    input {
        border-top: 1px solid transparent;
        border-left: 1px solid transparent;
        border-right: 1px solid transparent;
        border-bottom: 1px solid #DEE5E6;
        background-color: transparent;
        outline: none;
        border-radius: 0;
        width: 100%;
        margin: 10px 0;
    }
}
.color-error{
  color: #E25757;
}
.popover-freight .el-select-dropdown{
      z-index: 2034 !important;
}
.el-select-dropdown__item{
      line-height: 32px;
}
.scrollheaderfix{
  .popover-table-header{
    display: flex;
  }
}
.popscroll{
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
}
.popzindex{
  z-index: 8 !important;
}
.btn:disabled{
  opacity: 0.4;
}
</style>
